module.exports = __webpack_public_path__ + "static/media/nomobile.d6f40875.svg";